import { CONTACT, NAV_LINKS, CAREERS } from "@/components/vss/data";

export default function Footer() {
  const scrollTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  const year = new Date().getFullYear();

  return (
    <footer
      className="relative border-t border-slate-200 bg-white pt-20 pb-10"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-5">
            <button onClick={scrollTop} className="flex items-center gap-3">
              <img
                src="/logo.png"
                alt="Visionary Staffing Solutions LLP"
                className="h-16 w-auto"
              />
            </button>
            <p className="mt-6 text-slate-600 leading-relaxed max-w-[46ch]">
              Visionary Staffing Solutions LLP — Enterprise Technology Talent.
              Delivered with Speed. Built for Scale.
            </p>
            <div className="mt-6 font-mono-a text-[11px] uppercase tracking-[0.28em] text-slate-500">
              Pune · Vadodara
            </div>
            <div className="mt-2">
              <a
                href={`mailto:${CONTACT.general}`}
                className="text-teal-700 hover:text-teal-600 link-underline break-all"
                data-testid="footer-general-email"
              >
                {CONTACT.general}
              </a>
            </div>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="font-mono-a text-[11px] uppercase tracking-[0.28em] text-slate-500 mb-4">
              Navigate
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    href={l.href || `#${l.id}`}
                    className="text-slate-700 hover:text-teal-700 link-underline"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#contact"
                  className="text-slate-700 hover:text-teal-700 link-underline"
                  data-testid="footer-link-contact"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="font-mono-a text-[11px] uppercase tracking-[0.28em] text-slate-500 mb-4">
              Capabilities
            </div>
            <ul className="space-y-3 text-slate-700">
              <li>Contingent & Contract Staffing</li>
              <li>Dedicated Engineering Pods</li>
              <li>SOW & Outcome Delivery</li>
              <li>Hire-Train-Deploy Pipelines</li>
              <li>Cloud · DevOps · Data · AI</li>
            </ul>
          </div>

          {/* Candidates: the careers portal, the one registration page, and the published Visionary policies. The legal pages are
              linked, never copied here, so a wording change takes effect in one place. */}
          <div className="col-span-6 lg:col-span-2" data-testid="footer-candidates">
            <div className="font-mono-a text-[11px] uppercase tracking-[0.28em] text-slate-500 mb-4">
              Candidates
            </div>
            <ul className="space-y-3">
              <li><a href={CAREERS.portal} className="text-slate-700 hover:text-teal-700 link-underline" data-testid="footer-careers">Careers</a></li>
              <li><a href={CAREERS.register} className="text-slate-700 hover:text-teal-700 link-underline" data-testid="footer-join-talent-network">Join Our Talent Network</a></li>
              <li><a href={CAREERS.privacy} className="text-slate-700 hover:text-teal-700 link-underline" data-testid="footer-privacy">Privacy</a></li>
              <li><a href={CAREERS.terms} className="text-slate-700 hover:text-teal-700 link-underline" data-testid="footer-terms">Terms</a></li>
              <li><a href={CAREERS.candidatePrivacy} className="text-slate-700 hover:text-teal-700 link-underline" data-testid="footer-candidate-privacy">Candidate Privacy</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-slate-500 font-mono-a uppercase tracking-[0.22em]">
            © {year} Visionary Staffing Solutions LLP · All rights reserved
          </div>
          <div className="text-xs text-slate-400 font-mono-a uppercase tracking-[0.22em]">
            v1.0 · Enterprise Technology Talent
          </div>
        </div>
      </div>
    </footer>
  );
}
